export default {
  title: 'Dispositivos',
  subtitle: 'Tags e localizadores da conta.',
  add: 'Ativar dispositivo',
  search_placeholder: 'Buscar por nome, categoria…',
  empty: 'Nenhum dispositivo cadastrado ainda.',
  empty_hint: 'Ative sua primeira tag para começar a localizar.',
  no_name: 'Sem nome',
  empty_filtered: 'Nenhum dispositivo corresponde aos filtros.',
  filter_update: 'Filtrar por atualização',
  filter_all: 'Todas',
  last_seen_never: 'Nunca detectada',
  last_seen_now: 'Última detecção agora mesmo',
  last_seen: 'Última detecção {time}',
  table: {
    device: 'Dispositivo',
    category: 'Categoria',
    detection: 'Detecção',
    battery: 'Bateria',
    status: 'Status',
  },
  detail: {
    back_to_map: 'Voltar ao mapa',
    last_location: 'Última localização',
    detection: 'Detecção',
    accuracy: 'Precisão',
    source: 'Origem',
    battery: 'Bateria',
    identification: 'Identificação',
    serial: 'Serial',
    provider_id: 'ID no provedor',
    groups: 'Grupos',
    no_groups: 'Nenhum grupo.',
    recent_history: 'Histórico recente',
    retention: 'Retenção do plano: {days} dias.',
    hide_map: 'Ocultar mapa',
    show_map: 'Ver no mapa',
    positions: '{count} posição | {count} posições',
    last_detection: 'Última detecção',
    recent_observations: 'Observações recentes',
    no_detections: 'Nenhuma detecção ainda.',
    edit_tag: 'Editar tag',
    discard_changes: 'Descartar as alterações?',
    unavailable: 'Esta tag não está mais disponível para você.',
    not_found: 'Tag não encontrada ou sem permissão de acesso.',
    waiting_first: 'A localização aparecerá quando recebermos a primeira detecção.',
  },
}
